var brand = '';
var sku = '';
var spinsrc = '';
var sirv = false;
var halfbtn = false;
function removepopup(){
  $('.popup-overlay').hide();
  $('.popup-container').hide();
}
function halfbutton(half){
    if(half){
     $('.spin-btn').addClass('half-btn');
     $('.cert-btn').addClass('half-btn');
     }
     return(true);
}

jQuery(document).ready(function ($) {
  
  if($('.pro-container').length > 0){
    brand = $('.pro-container').attr('brand');
    sku = $('.pro-container').attr('sku');
  }

  

        // show spin image  
        if(brand == 'Pink Kimberley' || brand == 'Pink Kimberley Diamonds'){
          spinsrc = "https://samsgroup.sirv.com/products/" + sku + "/" + sku + ".spin";
        var pdfsrc = 'https://samsgroup.sirv.com/pdf/'+sku+'.pdf'
        $.ajax( pdfsrc, {
          statusCode: {
            404: function() {
  
              },
            200: function() {
                $('.cert-btn').attr('href',pdfsrc).removeClass('unavailable');
              halfbtn = halfbutton(halfbtn);
            }
          }
        });
        }
        if(brand == 'Sapphire Dreams'){
          spinsrc = "https://samsgroup.sirv.com/SD-Product/Sapphire%20Dreams%20Products/" + sku + "/" + sku + ".spin";
          $.ajax({
            type: "GET",
            url: "https://samsgroup.sirv.com/SD-Product/plytix_feed.xml", // Replace with the path to your XML file
            dataType: "xml",
            success: function(xml) {

                var found = false;
                $(xml).find("product").each(function() {
                  var xmlsku = $(this).find("SKU").text();
                  if (xmlsku === sku) {
                    found = true;
                    return false; // Exit the loop if the SKU is found
                  }
                });
        
                // Display the result
                if (found) {
                  $('.cert-btn').attr('href','https://samsgroup.info/php/cert-a5-pdf.php?sku='+sku).removeClass('unavailable');
                  halfbtn = halfbutton(halfbtn);
                } else {
                  console.log("SKU not found.");
                }
            },
            error: function() {
              console.log("Error loading XML data.");
            }
          });
        }       
        $.ajax( spinsrc, {
          statusCode: {
            404: function() {
  
              },
            200: function() {
                $('.sirv-container').append('<iframe src="'+spinsrc+'" title="360"></iframe>');
                $('.spin-btn').removeClass('unavailable');
                halfbtn = halfbutton(halfbtn);
            }
          }
        });

        if ($('.spin-btn').hasClass('unavailable') && !$('.cert-btn').hasClass('unavailable')) {
          $('.cert-btn').addClass('full-width-btn');
        }
        // if (!$('.spin-btn').hasClass('unavailable') && $('.cert-btn').hasClass('unavailable')) {
        //   $('.spin-btn').addClass('full-width-btn');
        // }
  
        $('.spin-btn').click(function () {
            $('#sirv360').show();
            $('.popup-overlay').show();
        });
        $('.popup-overlay').click(removepopup);
        $('.cancel-btn').click(removepopup);

  
});